module.exports = __webpack_public_path__ + "media/images/logo-29515449d781c4d8e6ff88068f2cce45.svg";